import type { Tour } from "@/shared/ui/tour";

export const ONBOARDING_TOUR_ID = "post-onboarding";

export const getOnboardingTour = (t: (key: string) => string): Tour => ({
  id: ONBOARDING_TOUR_ID,
  steps: [
    {
      id: "search-profile",
      title: t("Your search profile"),
      content: t(
        "These are tenders based on your tags. Refine your filters to see what's most relevant for your organisation.",
      ),
      side: "right",
    },
    {
      id: "notifications",
      title: t("Stay Updated"),
      content: t(
        "When new tenders matching your profile are published, you'll receive notifications here. Never miss an opportunity again!",
      ),
      side: "bottom",
    },
  ],
});
